export default __webpack_public_path__ + "static/media/bdt.da412432.svg";